// FIXME find lightweight schema validator
export function getValue (value: string): string | boolean {
  if (value === 'true') return true
  if (value === 'false') return false
  return value
}
